import styles from "./styles.scss";
import clsx from "clsx";
import { FC } from "react";
import { Search, Time } from "@/assets/icons";
import { SearchSuggestionsProps } from "@/pages/inbox/components/search-suggestions/types";
import { map } from "lodash";
import { Loader } from "@/components";

export const SearchSuggestions: FC<SearchSuggestionsProps> = ({
  isEmptySearchForm = false,
  onSelect,
  data,
  isLoading,
  error,
}) => {
  const renderDropdown = () => {
    if (isLoading) {
      return (
        <li className={clsx(styles.listItem, styles.listItemMobile)}>
          <Loader />
        </li>
      );
    }

    if (error) {
      return (
        <li className={clsx(styles.listItem, styles.listItemMobile)}>Error</li>
      );
    }

    return data?.length ? (
      map(data, (item, index) => {
        return (
          <li
            key={`${item}-${index}`}
            className={clsx(styles.listItem, styles.listItemMobile)}
            onClick={() => onSelect(item)}
          >
            {isEmptySearchForm ? (
              <Time className={styles.listIcon} />
            ) : (
              <Search className={styles.listIcon} />
            )}
            <span>{item.RequestId || item.ReferenceNumber}</span>
          </li>
        );
      })
    ) : (
      <li className={clsx(styles.listItem, styles.listItemMobile)}>No data</li>
    );
  };

  return (
    <div
      className={clsx(styles.searchSuggestionsContainer)}
      style={{
        height: "auto",
      }}
    >
      <div className={clsx(styles.sectionHeader)}>Recent searches</div>
      <ul>{renderDropdown()}</ul>
    </div>
  );
};
